import React, {useState, useEffect, useRef} from "react";
import {Card, Col, Form, Badge, Accordion} from "react-bootstrap";
import {Link} from "react-router-dom";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import {createSelector} from "reselect";
import {useDispatch, useSelector} from "react-redux";
import {getCategoryList as onGetCategoryList} from "../../../slices/category/thunk";
import {getBrandList as onGetBrandList} from "../../../slices/brand/thunk";
import {getColorsList as onGetColorsList} from "../../../slices/color/thunk";

const FilteredProduct = ({setSearchData}: any) => {

    const dispatch = useDispatch<any>();

    const selectBrandList = createSelector(
        (state: any) => state.Brand,
        (brand) => ({
            brandList: brand.brandList
        })
    );

    const selectCategoryList = createSelector(
        (state: any) => state.Category,
        (category) => ({
            categoryList: category.categoryList
        })
    );

    const selectColorsList = createSelector(
        (state: any) => state.Colors,
        (colors) => ({
            colorsList: colors.colorsList
        })
    );

    const {colorsList} = useSelector(selectColorsList);
    const {categoryList} = useSelector(selectCategoryList);
    const {brandList} = useSelector(selectBrandList);

    const [minCost, setMinCost] = useState(0);
    const [maxCost, setMaxCost] = useState(2500);
    const [checkedItems, setCheckedItems] = useState<string[]>([]);
    const isFirstRender = useRef(true);


    const handleChange = (event: any) => {
        const {value, checked} = event.target;
        setCheckedItems((prev: any) =>
            checked ? [...prev, value] : prev.filter((id: any) => id !== value)
        );
    };

    const clearAll = () => {
        setSearchData((state: any) => ({
            ...state,
            name: "",
            categoryId: null,
            brandId: [],
            colorId: null,
            minPrice: null,
            maxPrice: null,
            isActive: true
        }))
        setCheckedItems([]);
        setMinCost(0);
        setMaxCost(2500);
    }

    //Category
    const handleCategory = (value: any) => {
        setSearchData((state: any) => ({
            ...state,
            categoryId: value
        }))
    }

    //Color
    const filterColors = (value: any) => {
        console.log(value)
        setSearchData((state: any) => ({
            ...state,
            colorId: value
        }))
    }

    const handleSearchData = (ele: any) => {
        setSearchData((state: any) => ({
            ...state,
            name: ele.target.value
        }))
    };

    //slider function
    const onUpDate = (value: any) => {
        setMinCost(value[0]);
        setMaxCost(value[1]);
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setSearchData((state: any) => ({
            ...state,
            minPrice: minCost,
            maxPrice: maxCost
        }))

    }, [minCost, maxCost]);

    useEffect(() => {
        let slider = document.getElementById("product-price-range");
        slider?.setAttribute("data-slider-color", "secondary");
    }, [])

    useEffect(() => {
        dispatch(onGetCategoryList());
        dispatch(onGetBrandList());
        dispatch(onGetColorsList());
    }, [dispatch]);


    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setSearchData((state: any) => ({
            ...state,
            brandIds: checkedItems
        }))

    }, [checkedItems]);

    return (
        <React.Fragment>
            <Col xxl={3}>
                <Card>
                    <Card.Header className="d-flex align-items-center">
                        <div className="flex-grow-1">
                            <h5 className="card-title mb-0">Filters</h5>
                        </div>
                        <div className="flex-shrink-0">
                            <div className="text-reset text-decoration-underline cursor-pointer"
                                 onClick={clearAll}>Clear All
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <div className="search-box mb-3">
                            <Form.Control
                                type="text"
                                id="searchResultList"
                                placeholder="Search products..."
                                onChange={handleSearchData}
                            />
                            <i className="ri-search-line search-icon"></i>
                        </div>

                        <Accordion defaultActiveKey="0" className="filter-panel" id="accordionExample" flush>

                            {/*<Accordion.Item eventKey="0">*/}
                            {/*    <Accordion.Header id="categoryAccordion">Product Category</Accordion.Header>*/}
                            {/*    <Accordion.Body>*/}
                            {/*        <ul className="list-unstyled mb-0 filter-list">*/}
                            {/*            {categoryList.content && categoryList.content.map((item: any, index: any) => (*/}
                            {/*                <li key={index}>*/}
                            {/*                    <Link to="#" className="d-flex py-1 align-items-center">*/}
                            {/*                        <div className="flex-grow-1">*/}
                            {/*                            <h5 className="fs-sm mb-0 listname"*/}
                            {/*                                onClick={() => handleCategory(item.id)}>{item.name}</h5>*/}
                            {/*                        </div>*/}
                            {/*                    </Link>*/}
                            {/*                </li>*/}
                            {/*            ))}*/}

                            {/*        </ul>*/}
                            {/*    </Accordion.Body>*/}
                            {/*</Accordion.Item>*/}

                            <Accordion.Item eventKey="3">
                                <Accordion.Header id="brandsAccordion">
                                    Brands
                                    <Badge bg="primary" className="ms-2 fs-xxs">
                                        {brandList.numberOfElements && brandList.numberOfElements}
                                    </Badge>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="d-flex flex-column gap-2 filter-check">

                                        {brandList.content && brandList.content.map((item: any, index: any) => (
                                            <Form.Check key={index}>
                                                <Form.Check.Input
                                                    type="checkbox"
                                                    value={item.id}
                                                    id={item.name}
                                                    onChange={handleChange}
                                                    checked={checkedItems.includes(item.id.toString())}
                                                />
                                                <Form.Check.Label htmlFor={item.name}>{item.name}</Form.Check.Label>
                                            </Form.Check>
                                        ))}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="2">
                                <Accordion.Header id="ColorsAccordion"> Colors</Accordion.Header>
                                <Accordion.Body>
                                    <div className="hstack gap-2 flex-wrap">
                                        {colorsList.content && colorsList.content.map((item: any, index: any) => (
                                            <button
                                                key={index}
                                                className={"btn shadow-lg"}
                                                style={{backgroundColor: item.heh}}
                                                onClick={() => filterColors(item.id)}>
                                                {item.name}
                                            </button>
                                        ))}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="1">
                                <Accordion.Header id="priceAccordion">
                                    Price
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Nouislider
                                        range={{min: 0, max: 2000}}
                                        start={[minCost, maxCost]}
                                        connect
                                        onSlide={onUpDate}
                                        id="product-price-range"
                                    />
                                    <div className="formCost d-flex gap-2 align-items-center mt-3">
                                        <Form.Control
                                            className="form-control-sm"
                                            type="text"
                                            id="minCost"
                                            value={`$ ${minCost}`}
                                            onChange={(e: any) => setMinCost(e.target.value)}
                                            readOnly
                                        />
                                        <span className="fw-semibold text-muted">to</span>
                                        <Form.Control
                                            className="form-control-sm"
                                            type="text"
                                            id="maxCost"
                                            value={`$ ${maxCost}`}
                                            onChange={(e: any) => setMaxCost(e.target.value)}
                                            readOnly
                                        />
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>
                    </Card.Body>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default FilteredProduct;